export const CLASS_BLOCKER_MODAL = 'blocker-modal';
export const BLOCKER_MODAL_CONTAINER = '.page';
export const CLASS_CONTAINER_BLOCKED = 'page--events';
